module.exports = __webpack_public_path__ + "img/day-cloud.7442de2a.svg";